import { isAuthenticated } from 'modules/common/permissions';

import FileViewer from '../FileViewer';
import { initFileViewer } from './sagas';

export default [
  {
    component: FileViewer,
    exact: true,
    path: '/files/viewer/',
    permissions: [isAuthenticated],
    saga: initFileViewer,
  },
];
